module.exports = __webpack_public_path__ + "img/Screenshot_5.b9cd38e9.png";